"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SingleCheckboxSchema = void 0;
exports.default = SingleCheckbox;
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const react_hook_form_1 = require("react-hook-form");
const zod_1 = require("zod");
exports.SingleCheckboxSchema = ((options) => {
    return {
        options,
        create: (fieldName, validation) => {
            return zod_1.z.object({ [fieldName]: validation });
        },
    };
})({
    default: zod_1.z.boolean(),
});
function SingleCheckbox({ name, label, disabled = false }) {
    const { control } = (0, react_hook_form_1.useFormContext)();
    const { field } = (0, react_hook_form_1.useController)({ name, control });
    return ((0, jsx_runtime_1.jsx)(material_1.FormControl, { children: (0, jsx_runtime_1.jsx)(material_1.FormControlLabel, { control: (0, jsx_runtime_1.jsx)(material_1.Checkbox, { name: name, color: "secondary", onChange: (e) => {
                    field.onChange(e.target.checked);
                }, checked: field.value === true, disabled: disabled }), label: label, componentsProps: {
                typography: {
                    variant: 'bodyMediumBook',
                    color: 'text.secondary',
                },
            } }) }));
}
//# sourceMappingURL=SingleCheckbox.js.map